import ArtistSearchBaseController from "./artist_search_base"

export default class extends ArtistSearchBaseController {
  connect() {
    super.connect()
  }

  // Implementation of abstract methods from base class
  getCallingControllerType() {
    return "track_primary"
  }

  getHiddenInputName() {
    return "track[primary_artist_ids][]"
  }

  getHiddenInputId(artistId) {
    // Note: We don't have access to track.id here, so we use a simpler pattern
    // The template should match this pattern
    return `track_primary_artist_${artistId}`
  }
}
